import React, { PropsWithChildren } from "react";
import clsx from "clsx";

import Button from "@material-ui/core/Button";

import useStyles from "./styles";

interface IProps {
  icon: React.ReactNode;
  className?: string;
}

const ViewMediaButton = (props: PropsWithChildren<IProps>) => {
  const { className, icon, children } = props;

  const classes = useStyles();

  return (
    <Button
      className={clsx(classes.viewMedia, className)}
      endIcon={icon}
      disabled
    >
      {children}
    </Button>
  );
};

export default React.memo(ViewMediaButton);
